import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { AuthActions } from '../Store/Actions';
import { showErrorToastMessage } from '../Services/ToastService';
import RouteUrls from '../Router/RouteUrls';

const useAuth = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleAuthSuccess = async authData => {
    try {
      await dispatch(AuthActions.login(authData));
      history.push(RouteUrls.rewardDashboard);
    } catch (error) {
      showErrorToastMessage(error.message);
    }
  };

  const handleGoogleSignin = response => {
    if (!response) return;

    const accessToken = response.credential;
    const decodedInfo = jwtDecode(response.credential);

    if (!accessToken) {
      showErrorToastMessage('Failed to get access token');
      return;
    }

    const authData = {
      email: decodedInfo.email,
      fullName: decodedInfo.name,
      accessToken,
      maxAge: 3600,
      provider: 'google'
    };

    handleAuthSuccess(authData);
  };

  return { handleGoogleSignin };
};

export default useAuth;
